<template>
    <div class="panel notes mb-4">
        <h5>Notes &amp; Alerts</h5>

        <div v-if="moments && canAdd" class="row mb-4">
            <div class="col-sm-6">
                <input 
                    type="text" 
                    placeholder="Leave an important alert ..." 
                    class="w-100" 
                    v-model="text" 
                    @keyup.enter="saveNote">
            </div>
            <div class="col-sm-6 d-flex">
                <v-select
                    v-model="selectedMoment"
                    :options="moments" 
                    :searchable="false"
                    label="description"
                    placeholder="- Select moment -"
                    @input="updateMoment">
                </v-select>
            
                <button type="button" class="btn blue ml-3" @click="saveNote">
                    <i class="ico-add"></i>
                    Add note
                </button>
            </div>
        </div>

        <ul v-if="form.notes && form.notes.length > 0">
            <li class="d-flex my-3 relative" v-for="(note, index) in form.notes">
                <note :reservation="form" :index="index"></note>
            </li>
        </ul>
        <div v-else>
            No notes found.
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Note from './Note'
    
    export default {
        props: {
            canAdd: {
                type: Boolean,
                default: true
            }
        },
        data: function() {
            return {
                form: {
                    notes: [],
                    selectedMoment: null,
                    selectedType: null
                },
                text: '',
                selectedMoment: null,
            }
        },
        created: function() {
            if (this.getClonedReservation) {
                this.form = JSON.parse(JSON.stringify(this.getClonedReservation));
            }
        },
        asyncComputed: {
            async types() {
                try {
                    let response = await axios.get('/api/settings/GetNoteVisibilityList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.type) {
                            this.selectedType = response.data.find(item => item.id === this.form.type);
                        }
                        else {
                            this.selectedType = response.data[0];
                            this.form.type = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
            async moments() {
                try {
                    let response = await axios.get('api/settings/GetNoteVisibilityMomentTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.moment) {
                            this.selectedMoment = response.data.find(item => item.id === this.form.moment);
                        }
                        else {
                            this.selectedMoment = response.data[0];
                            this.form.moment = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
            ]),
        },
        methods: {
            ...mapActions([
                'updateClonedReservation'
            ]),
            updateType: function() {
                this.form.type = this.selectedType.id || null;
            },
            updateMoment: function() {
                this.form.moment = this.selectedMoment.id || null;
            },
            saveNote: function() {
                if (this.text.length > 2) {
                    if (this.form.notes === undefined || !this.form.notes) {
                        this.$set(this.form, 'notes', []);
                    }

                    this.form.notes.push({
                        noteVisibilityMomentType: this.selectedMoment.id,
                        type: this.selectedType.id,
                        note: this.text
                    });

                    this.text = '';

                    this.$emit('updateNotes', this.form.notes);
                }
            }
        },
        components: {
            vSelect: extendedVSelect,
            Note
        }
    }
</script>


// WEBPACK FOOTER //
// Notes.vue?403178cf